import { render } from "./MarketingPreferencesAttributes.vue?vue&type=template&id=74eacfb3&scoped=true"
import script from "./MarketingPreferencesAttributes.vue?vue&type=script&lang=js"
export * from "./MarketingPreferencesAttributes.vue?vue&type=script&lang=js"

import "./MarketingPreferencesAttributes.vue?vue&type=style&index=0&id=74eacfb3&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74eacfb3"]])

export default __exports__